import { Link } from "react-router-dom";
import type { Movie } from "@/lib/types";
import { formatViews } from "@/lib/movies";

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

export default function MovieCard({ movie, showSummary = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg border border-background-200/70 bg-background-100/60 overflow-hidden transition-all duration-300 hover:border-primary-400/70 hover:bg-background-100 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}影视海报`}
          title={`${movie.title}剧情介绍与分析`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/10 to-transparent"></div>

        <span className="absolute top-2.5 right-2.5 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-background-50/85 backdrop-blur-sm text-accent-500 text-xs font-label font-medium">
          <i className="ri-star-fill text-[11px]"></i>
          {movie.rating.toFixed(1)}
        </span>

        <span className="absolute bottom-2.5 left-2.5 inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary-500/90 text-foreground-50 text-[11px] font-medium">
          {movie.type === "剧集" ? "全剧集" : "电影"}
        </span>

        {movie.episodes && (
          <span className="absolute bottom-2.5 right-2.5 px-2 py-0.5 rounded-md bg-background-50/85 text-foreground-200 text-[11px] font-label">
            {movie.episodes.length} 集
          </span>
        )}
      </div>

      <div className="p-3.5 md:p-4">
        <div className="flex items-center gap-2 text-[11px] text-foreground-600 mb-2">
          <span>{movie.year}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-700"></span>
          <span>{movie.country}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-700"></span>
          <span className="truncate">{movie.genres.slice(0, 2).join(" · ")}</span>
        </div>
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-50 truncate group-hover:text-accent-500 transition-colors">
          {movie.title}
        </h3>
        {showSummary && (
          <p className="mt-1.5 text-xs leading-relaxed text-foreground-500 line-clamp-2">
            {movie.summary}
          </p>
        )}
        <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-600">
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(movie.views)}
          </span>
          <span className="inline-flex items-center gap-1 text-foreground-500 group-hover:text-accent-500 transition-colors">
            查看解析
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}